"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiOptionsFab = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var react_1 = require("react");
var styles_1 = require("./styles");
var atoms_1 = require("../../atoms");
var MultiOptionsFab = function (_a) {
    var options = _a.options, id = _a.id, rest = __rest(_a, ["options", "id"]);
    var buttonRef = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var handleMenuItemClick = function (onClick) {
        // reset multiOptionsFab open state after selecting menu item
        setAnchorEl(null);
        if (typeof onClick === 'function') {
            onClick();
        }
    };
    var open = Boolean(anchorEl);
    var popoverId = open ? "".concat(id, "-Popover") : undefined;
    var classes = (0, styles_1.useStyles)();
    var getElementPosition = function () {
        if (buttonRef.current) {
            return {
                top: buttonRef.current.getBoundingClientRect().top - 8,
                left: buttonRef.current.getBoundingClientRect().right,
            };
        }
        return { top: 0, left: 0 };
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(core_1.Button, __assign({ id: id, type: "button", color: "primary", variant: "contained", className: open ? classes.fabClose : classes.fabActions, onClick: handleClick, ref: buttonRef }, rest, { children: [open ? (0, jsx_runtime_1.jsx)(icons_1.Close, {}) : (0, jsx_runtime_1.jsx)(icons_1.MoreVert, {}), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.fabText }, { children: open ? 'CLOSE' : 'ACTIONS' }))] })), (0, jsx_runtime_1.jsx)(core_1.Popover, __assign({ id: popoverId, "data-testid": "simple-popover", open: open, classes: { paper: classes.paper }, anchorReference: "anchorPosition", anchorPosition: getElementPosition(), onClose: handleClose, role: "listbox", anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                } }, { children: (0, jsx_runtime_1.jsx)(core_1.MenuList, __assign({ className: classes.menuList }, { children: Array.from(options).map(function (_a) {
                        var icon = _a.icon, text = _a.text, _b = _a.onClick, onClick = _b === void 0 ? function () { } : _b, optionId = _a.id, disabled = _a.disabled;
                        return ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ id: optionId, className: classes.menuItem, onClick: function () { return handleMenuItemClick(onClick); }, disabled: !!disabled }, { children: [(0, jsx_runtime_1.jsx)(core_1.ListItemIcon, __assign({ className: classes.itemIcon }, { children: icon })), (0, jsx_runtime_1.jsx)(atoms_1.Text, { children: text })] }), text));
                    }) })) }))] }));
};
exports.MultiOptionsFab = MultiOptionsFab;
